import React from "react";
import { Link } from "react-router-dom";
import "../../styles/CardStory.css";
import premiumLogo from "./../../assets/premium.png"


const CardStory = ({ read }) => {
  return (
    <div className="cardstory">
      <div className="cardstory-content">
        <div className="cardstory-content-top">
          <div className="cardstory-content-top-title">
            <h6>Title</h6>
          </div>
          <div className="cardstory-content-top-test">
            <h6>Test</h6>
          </div>
        </div>
        <hr />
        <div className="cardstory-content-bottom">
          <div className="cardstory-content-bottom-left">
            <h3>{read.title?.substring(0, 12)}...</h3>
          </div>
          <div className="cardstory-content-bottom-right">
            <h3>{read.quizzes}</h3>
          </div>
        </div>
      </div>
      <div className="medBut-div">
        <Link to={`/reading-inside/${read._id}`}>
        <button className="medBut">Download Pdf</button>
        </Link>
        
      </div>
      <div className="medBut-div">
        <Link to={`/reading-inside/${read._id}`}>
          <button className="medBut-tranparent">Start</button>
        </Link>
      </div>
      {read.membership === "premiumPlan" ? (
        <div className="premium-read">
          <img src={premiumLogo} alt="premiumLogo"/>
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default CardStory;
